export default __webpack_public_path__ + "static/media/social51.72cdaf41.jpeg";